<section
	class="relative"
	*transloco="let t; prefix: 'property-details.hero-section'">
	<div class="swiper heroSwiper">
		<div class="swiper-wrapper">
			@if (data.combinedArray.length) {
			@for (photo of data.photos.items; track photo; let i = $index) {
			<div class="swiper-slide">
				<div class="grid grid-cols-5 grid-rows-2 gap-3 rounded-medium overflow-hidden h-[490px]">
					<div class="row-span-2 col-span-5 lg:col-span-3">
						<div class="flex flex-col relative h-full">
							@if (photo.isDefault) {
								@if (data.model.isSold) { 
									<div class="backdrop-blur-sm backdrop-grayscale-[0.8] backdrop-contrast-50 h-full w-full absolute top-0 flex justify-center items-center rounded-lg overflow-hidden z-10">
										<div class="w-[144px]">
											<img class="w-full" src="./assets/img/keys.svg" alt="">
										</div>
									</div>
									<div class="sold-banner"> SOLD </div> 
								} @else {
									<div class="relative px-4 py-5 z-10 flex flex-col justify-between h-full">
										<div
										class="relative px-4 py-5 z-10 flex flex-col justify-between h-full">
											<div class="flex flex-row justify-between">
												<div class="flex flex-row flex-wrap gap-2 text-white">
													<div *ngIf="data.model.isHot && !data.model.isSold" class="property-label red max-h-fit">
														<i class="icon-fire-alt mr-1"></i>
														<span>{{ t("tags.hot") }}</span>
													</div>
													<div *ngIf="data.model.isExclusive && !data.model.isSold"
														class="property-label bg-[#059B9C] max-h-fit flex items-center gap-1">
														<svg width="10" height="10" viewBox="0 0 10 10" fill="none"
															xmlns="http://www.w3.org/2000/svg">
															<path
																d="M10 5.12333V9.74463C10 9.8861 9.87618 10 9.72416 10H8.78928C8.63647 10 8.51266 9.88538 8.51266 9.74463V5.3446C8.51266 5.28366 8.48915 5.22417 8.44526 5.17774L5.20884 1.7027C5.09835 1.58445 4.90087 1.58445 4.79038 1.7027L1.55395 5.17774C1.51085 5.22417 1.48656 5.28366 1.48656 5.3446V8.65569C1.48656 8.79716 1.61038 8.91106 1.76318 8.91106H4.01144C4.16425 8.91106 4.28806 8.79643 4.28806 8.65569V5.8713C4.28806 5.72983 4.41188 5.61521 4.56469 5.61521H5.44315C5.59596 5.61521 5.71977 5.72983 5.71977 5.8713V9.74391C5.71977 9.88537 5.59596 9.99928 5.44315 9.99928H0.276624C0.123815 9.99928 0 9.88465 0 9.74391V5.12261C0 5.05949 0.0250764 4.99855 0.0705274 4.95139L4.79429 0.084881C4.904 -0.0282937 5.09521 -0.0282937 5.20492 0.084881L9.92869 4.95212C9.97414 4.99927 9.99922 5.06021 9.99922 5.12333H10Z"
																fill="white" />
														</svg>
														<span>{{t('tags.exclusive')}}</span>
													</div>
													<div
														*ngIf="data.model?.auctionRound && !data.model.isSold"
														class="property-label bg-[#3B61C1] max-h-fit"> {{ t("tags.auction") }} </div>
													<div
														*ngIf="data.model?.isSponsored"
														class="property-label orange max-h-fit"> {{ t("tags.sponsored") }} </div>
												</div>
											</div>
											<div class="flex flex-row justify-end">
												<div class="px-1.5 h-6 bg-slate-600/40 rounded backdrop-blur-[3px] inline-flex justify-start items-center gap-1.5">
													<span class="text-white text-xs font-normal">{{i + 1}}</span><span class="text-white text-xs font-normal">/</span><span class="text-white text-xs font-normal">{{getRealSlideCount()}}</span>
												</div>
											</div>
										</div>
										<ng-container *ngIf="isPreapproved()">
											<div 
												[ngClass]="{'absolute bottom-0 left-0 right-0 z-10 w-full h-[29px]': isPreapproved()}"
												class="">
												<div
													class="bg-[#037079CC] py-2 px-4 backdrop-blur rounded-b-sm flex flex-row justify-center gap-1 w-full">
													<span class="text-white font-bold text-[0.546875rem]">{{ t("default-image.nbg-aproved")
														}}</span>
														<img class="h-[14px]" src="{{'../../../../../assets/svgs/nbg-logo' + (activeLang === 'el' ? '-white' : '') + '.svg'}}" />
												</div>
											</div>
										</ng-container>
										<img
											[src]="data.model.defaultPhoto?.uri ? data.model.defaultPhoto?.uri+(data.model.publishedVersion ? '?v='+data.model.publishedVersion : '') : data.model.defaultImagePath"
											class="w-full h-full object-cover object-center img-disable-context absolute top-0 left-0 bottom-0 right-0 -z-1" />	
									</div>
								}
							}
							@else {
							<div class="relative px-4 py-5 z-10 flex flex-col h-full justify-end">
								<div class="flex flex-row justify-end">
									<div class="px-1.5 h-6 bg-slate-600/40 rounded backdrop-blur-[3px] inline-flex justify-start items-center gap-1.5">
										<span class="text-white text-xs font-normal">{{i + 1}}</span><span class="text-white text-xs font-normal">/</span><span class="text-white text-xs font-normal">{{getRealSlideCount()}}</span>
									</div>
								</div>
							</div>
							<img
								[src]="photo.uri"
								class="w-full h-full object-cover object-center img-disable-context absolute top-0 left-0 bottom-0 right-0 -z-1" />
							}
						</div>
					</div>
				</div>
			</div>
			}
		}
		</div>
	</div>
	<div class="custom-swiper-pagination"></div>
</section>